import moment from 'moment'

import { formatCurrency } from '@/utils/currencyHelpers'
import { useBankAccount } from '../../helpers'
import { Card, CardColors, Icon, Popover, Popup, Text } from '@/ui'
import { DATE_FORMATS } from '@/utils/dateHelpers'
import { TypographyStyles } from '@/styles'
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons'
export const ContractorPayrollOverview = ({
  total,
  payDate,
}: {
  total: number
  payDate: string
}) => {
  const bankAccount = useBankAccount()

  return (
    <div className="flex flex-col md:flex-row gap-4">
      <div className="w-full md:w-1/2">
        <Card color={CardColors.LEVEL_1} className="p-4">
          <div className="flex items-start gap-2">
            <Text variant={TypographyStyles.BODY_MD}>Contractor Pay Date</Text>
            <Popup
              content="This is the date your contractor payment will be debited into their account."
              trigger={<Icon icon={faInfoCircle} />}
            />
          </div>
          <Text variant={TypographyStyles.H1} className="amount mt-2">
            {moment(payDate).format(DATE_FORMATS.DISPLAY_LONG)}
          </Text>
        </Card>
      </div>
      <div className="w-full md:w-1/2">
        <Card color={CardColors.LEVEL_1} className="p-4">
          <div className="flex items-start gap-2">
            <Text variant={TypographyStyles.BODY_MD}>
              Withdrawn from Bank Account
              <br />
              {bankAccount?.account_type} {bankAccount?.hidden_account_number}
            </Text>
            <Popover>
              <Popover.Trigger>
                <Icon icon={faInfoCircle} />
              </Popover.Trigger>
              <Popover.Content>
                <Text>
                  This is the amount that will be taken from your attached bank
                  account for this contractor payment.
                </Text>
              </Popover.Content>
            </Popover>
          </div>
          <Text variant={TypographyStyles.H1} className="amount mt-2">
            {formatCurrency(total)}
          </Text>
        </Card>
      </div>
    </div>
  )
}
